import { call, put, takeLatest } from 'redux-saga/effects';
import * as Actions from './ReceiptActions';
import { actions } from './ReceiptReducer';
import { addLoadingMessage, removeLoadingMessage } from '../app/AppActions';
import * as Api from 'api/ReceiptApi';
import { getText } from 'helpers/app/getText';

export function* attemptGetReceipt({ payload: { data } }) {
  try {
    yield put(addLoadingMessage(getText('notifications:GETTING_RECEIPT')));
    const response = yield call(Api.attemptGetReceipt, data);
    yield put(Actions.attemptGetReceiptSucceed(response.data));
    yield put(removeLoadingMessage(getText('notifications:GETTING_RECEIPT')));
  } catch ({ response: { data } }) {
    yield put(Actions.attemptGetReceiptFailed(data));
    yield put(removeLoadingMessage(getText('notifications:GETTING_RECEIPT')));
  }
}

export function* attemptUpdateReceipt({ payload: { data } }) {
  try {
    yield put(addLoadingMessage(getText('notifications:UPDATING_RECEIPT')));
    yield call(Api.attemptUpdateReceipt, data);
    yield put(Actions.attemptUpdateReceiptSucceed());
    yield put(removeLoadingMessage(getText('notifications:UPDATING_RECEIPT')));
  } catch ({ response: { data } }) {
    yield put(Actions.attemptUpdateReceiptFailed(data));
    yield put(removeLoadingMessage(getText('notifications:UPDATING_RECEIPT')));
  }
}

export function* attemptSearchReceipt({ payload: { data } }) {
  try {
    yield put(addLoadingMessage(getText('notifications:SEARCHING_RECEIPTS')));
    const response = yield call(Api.attemptSearchReceipt, data);
    yield put(Actions.attemptSearchReceiptSucceed(response.data));
    yield put(removeLoadingMessage(getText('notifications:SEARCHING_RECEIPTS')));
  } catch ({ response: { data } }) {
    yield put(Actions.attemptSearchReceiptFailed(data));
    yield put(removeLoadingMessage(getText('notifications:SEARCHING_RECEIPTS')));
  }
}

function* receiptSaga() {
  yield takeLatest(actions.ATTEMPT_GET_RECEIPT, attemptGetReceipt);
  yield takeLatest(actions.ATTEMPT_UPDATE_RECEIPT, attemptUpdateReceipt);
  yield takeLatest(actions.ATTEMPT_SEARCH_RECEIPT, attemptSearchReceipt);
}

export default receiptSaga;
